// ============================================
// Main Entry Point (ES6 Modules)
// ============================================
// 이 파일은 ES6 모듈의 진입점입니다.
// 모든 모듈을 import하고, 기존 IIFE 파일과의 호환성을 유지합니다.

// ============================================
// 기반 모듈
// ============================================
import './modules/config.js';
import './modules/utils.js';

// ============================================
// Zustand Stores (상태 관리)
// ============================================
// Stores는 개별 모듈에서 직접 import하여 사용
// window 노출 제거됨 (2026-01-06)

// ============================================
// 앱 상태 (app.js에서 분리)
// ============================================
import './modules/app/index.js';

// ============================================
// 핵심 인프라
// ============================================
import './modules/modal-manager.js';
import './modules/auth/index.js';
import './modules/auth-events.js';

// ============================================
// 기능 모듈 (소형)
// ============================================
import './modules/image.js';

// ============================================
// 기능 모듈 (중형)
// ============================================
import './modules/profile/index.js';
import './modules/memory.js';
import './modules/settings/index.js';
import './modules/mypage/index.js';

// ============================================
// 거대 모듈 (분할됨)
// ============================================
import './modules/creator/index.js';
import './modules/creator-events.js';
import './modules/home/index.js';
import './modules/chat/index.js';

// ============================================
// 전역 이벤트 위임 (onclick 대체)
// ============================================
import './modules/global-events.js';

// ============================================
// 앱 초기화 (기존 app.js 대체)
// ============================================
import './app.js';

// ============================================
// 채팅 상태 관리 초기화
// ============================================
import { useChatStatusStore } from './stores/chatStatusStore.js';
import { startChatListListener, stopChatListListener } from './modules/chat/list.js';
import { initializeIAP } from './modules/payment/iap.js';

// ============================================
// 초기화
// ============================================
console.log('[main.js] ES6 모듈 로드 완료');

// DOMContentLoaded에서 추가 초기화 수행
document.addEventListener('DOMContentLoaded', () => {
  console.log('[main.js] DOMContentLoaded - 모듈 초기화 완료');

  // 오래된 pending 상태 정리
  const staleChatIds = useChatStatusStore.getState().cleanupStalePending();
  if (staleChatIds.length > 0) {
    console.log('[main.js] 타임아웃된 pending 상태 정리:', staleChatIds);
  }
});

// Firebase Auth 상태 변경 시 실시간 리스너 시작/종료
firebase.auth().onAuthStateChanged(user => {
  if (user) {
    // 로그인 시 채팅 리스트 실시간 리스너 시작 (user 직접 전달로 race condition 방지)
    startChatListListener(user);

    // 네이티브 앱에서 IAP 초기화 (로그인 후)
    if (window.Capacitor?.isNativePlatform?.()) {
      initializeIAP();
    }
  } else {
    // 로그아웃 시 리스너 종료
    stopChatListListener();
  }
});
